module.exports = __webpack_public_path__ + "media/device_images/macbook-draft-tracker-54e8a8de.svg";